import log from 'loglevel';
import { fromJS } from 'immutable';

export class BrowserStorage {
    constructor(private storage: Storage) {}

    getIn(
        [key, ...keys]: string[],
        defaultValue: string | undefined = undefined
    ): object | undefined {
        const jsonData: string = this.storage.getItem(key) || '{}';

        let data = {};
        try {
            data = typeof jsonData === 'string' ? JSON.parse(jsonData) : {};
        } catch (e) {
            log.warn('could not parse JSON data', jsonData);
        }

        const result = fromJS(data).getIn(keys || [], defaultValue);

        return result &&
            typeof result === 'object' &&
            'toJS' in result &&
            typeof result.toJS === 'function'
            ? result.toJS()
            : (result as any);
    }

    get(key: string, defaultValue: string | undefined = undefined): object | undefined {
        return this.getIn([key], defaultValue);
    }

    set(key: string, data: object) {
        this.storage.setItem(key, JSON.stringify(data));
    }

    update(key: string, data: object) {
        const currentStorageData = fromJS(this.get(key) || {});
        const newStorageData = currentStorageData.mergeDeep(fromJS(data) as any).toJS();

        this.set(key, newStorageData);
    }
}
